var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalBox",
    {
      class: [_vm.forgotEmailSent ? "d-flex justify-content-center h-100" : ""]
    },
    [
      !_vm.forgotEmailSent
        ? _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c("h3", [
                _vm._v(_vm._s(_vm.incorrectPin ? "Incorrect PIN" : "Enter PIN"))
              ]),
              _vm._v(" "),
              _c("CodeInput", {
                ref: "pin",
                staticClass: "input",
                attrs: {
                  loading: false,
                  fields: 4,
                  required: true,
                  type: "password"
                },
                on: { complete: _vm.onCompletePin, change: _vm.onChangePin }
              }),
              _vm._v(" "),
              _c(
                "VsButton",
                {
                  staticClass: "btn__action mt-4",
                  attrs: { disabled: _vm.disableButton },
                  on: {
                    click: _vm.submitPin,
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.submitPin($event)
                    }
                  }
                },
                [_vm._v("\n      Submit\n    ")]
              ),
              _vm._v(" "),
              _vm.incorrectPin
                ? _c(
                    "VsButton",
                    {
                      staticStyle: { color: "#CB225C" },
                      attrs: { loading: _vm.loading },
                      on: { click: _vm.forgotPin }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "profileSettings.form.settings.pin.forgot-pin"
                            )
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.forgotEmailSent
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center flex-column"
            },
            [
              _c("h4", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "profileSettings.form.settings.pin.message.reset-email"
                      )
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "VsButton",
                {
                  staticClass: "btn__action mt-4",
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("\n      Close\n    ")]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }